module.exports = __webpack_public_path__ + "47e37c1844119197acfb24d141d4aa84.png";